import React, { Component } from 'react';
import './Content/Styles/JobDetails.css';

class JobDetails extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <div>
                    <b>{this.props.position}</b>
                    <b className="positionTime">{this.props.startmonth}, {this.props.startyear} - { this.props.isPresent && "Present" }{ !this.props.isPresent && this.props.endmonth + "-" + this.props.endyear}</b>
                </div>
                    {
                        this.props.details != "" && this.props.details != null &&
                        <div>
                            {this.props.details}
                        </div>
                    }
                <div>
                    <ul>
                        {
                            this.props.jobDetails1 != "" && this.props.jobDetails1 != null && 
                            <li>
                                {this.props.jobDetails1}
                            </li>
                        }
                        {
                            this.props.jobDetails2 != "" && this.props.jobDetails2 != null &&
                            <li>
                                {this.props.jobDetails2}
                            </li>
                        }
                        {
                            this.props.jobDetails3 != "" && this.props.jobDetails3 != null &&
                            <li>
                                {this.props.jobDetails3}     
                            </li>
                        }
                        {
                            this.props.jobDetails4 != "" && this.props.jobDetails4 != null &&
                            <li>
                                {this.props.jobDetails4}     
                            </li>
                        }
                        {
                            this.props.jobDetails5 != "" && this.props.jobDetails5 != null &&
                            <li>
                                {this.props.jobDetails5}     
                            </li>
                        }
                        {
                            this.props.jobDetails6 != "" && this.props.jobDetails6 != null &&
                            <li>
                                {this.props.jobDetails6}     
                            </li>
                        }
                        {
                            this.props.jobDetails7 != "" && this.props.jobDetails7 != null &&
                            <li>
                                {this.props.jobDetails7}     
                            </li>
                        }
                    </ul>
                </div>
            </div>
        );
    }
}

export default JobDetails;
